"use strict";
import { ONE_MINUTE_MS, ONE_SECOND_MS } from "utilities/src/time/time";
export var PollingInterval = ((PollingInterval2) => {
  PollingInterval2[PollingInterval2["Slow"] = 5 * ONE_MINUTE_MS] = "Slow";
  PollingInterval2[PollingInterval2["Normal"] = ONE_MINUTE_MS] = "Normal";
  PollingInterval2[PollingInterval2["KindaFast"] = 30 * ONE_SECOND_MS] = "KindaFast";
  PollingInterval2[PollingInterval2["Fast"] = 15 * ONE_SECOND_MS] = "Fast";
  PollingInterval2[PollingInterval2["LightningMcQueen"] = 6 * ONE_SECOND_MS] = "LightningMcQueen";
  return PollingInterval2;
})(PollingInterval || {});
export const BIPS_BASE = 1e4;
